import {
	FETCH_PRACTICE_ALERTS,
	FETCH_PRACTICE_ALERTS_ERROR,
	SAVE_PRACTICE_ALERT,
	SAVE_PRACTICE_ALERT_ERROR,
	DELETE_PRACTICE_ALERT,
	DELETE_PRACTICE_ALERT_ERROR
} from '../ActionTypes';

const initActions = function (services) {
	const axiosCall = services.axios.Axios();

	const fetchPracticeAlertsRequest = () => ({
		type: FETCH_PRACTICE_ALERTS
	});

	const practiceAlertsError = (error) => ({
		type: FETCH_PRACTICE_ALERTS_ERROR,
		payload: error
	});

	const fetchLatestPracticeAlert = (practiceID) => {
		return async (dispatch) => {
			try {
				dispatch({ type: FETCH_PRACTICE_ALERTS });

				const response = await axiosCall.get(`/v1/PracticeAlerts/latest/${practiceID}`);

				if (response.data) {
					dispatch({
						type: SAVE_PRACTICE_ALERT,
						payload: response.data
					});
				} else {
					dispatch({
						type: FETCH_PRACTICE_ALERTS_ERROR,
						payload: "No alert found",
					});
				}
			} catch (error) {
				dispatch({
					type: FETCH_PRACTICE_ALERTS_ERROR,
					payload: error.message,
				})
			}
		};
	};

	const fetchAllPracticeAlerts = (practiceID) => {
		return async (dispatch) => {
			try {
				dispatch(fetchPracticeAlertsRequest());
				const response = await axiosCall.get(`/v1/PracticeAlerts/all/${practiceID}`);
				return response.data;
			} catch (error) {
				dispatch(practiceAlertsError(error.message));
			}
		};
	};

	const savePracticeAlert = (practiceID, alertText) => {
		return async (dispatch) => {
			try {
				const response = await axiosCall.post(`/v1/PracticeAlerts/${practiceID}`, { message: alertText });
				
				dispatch({
					type: SAVE_PRACTICE_ALERT,
					payload: response.data || { message: alertText, updatedBy: "You", updatedDate: new Date().toISOString() }
				});

				return response.data;
			} catch (error) {
				console.error("Failed to save practice alert:", error);
				dispatch({
					type: SAVE_PRACTICE_ALERT_ERROR,
					payload: error.message
				});
			}
		};
	};

	const deletePracticeAlert = (practiceID, id) => {
		return async (dispatch) => {
			try {
				await axiosCall.patch(`/v1/PracticeAlerts/${practiceID}`, { 
					alertId: id, 
					message: ""
				});

				dispatch({
					type: DELETE_PRACTICE_ALERT
				});
			} catch (error) {
				console.error("Failed to delete practice alert:", error);
				dispatch({
					type: DELETE_PRACTICE_ALERT_ERROR,
					payload: error.message
				});
			}
		};
	};

	return {
		fetchLatestPracticeAlert,
		fetchAllPracticeAlerts,
		savePracticeAlert,
		deletePracticeAlert
	};
};

export default initActions;
